'use client';

import { c as _c } from "react/compiler-runtime";
import { datadogRum } from '@datadog/browser-rum';
import { usePathname } from 'next/navigation';
import { type PropsWithChildren, useEffect } from 'react';
import { getExperimentForPage } from '../experiments';
type Props = PropsWithChildren<{
  serverSideExperimentDecision: string;
}>;
export function LogStaticExperiments(t0) {
  const $ = _c(9);
  const {
    children,
    serverSideExperimentDecision
  } = t0;
  const pathname = usePathname();
  let t1;
  if ($[0] !== pathname) {
    t1 = getExperimentForPage(pathname);
    $[0] = pathname;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const staticExperimentName = t1;
  let t2;
  if ($[2] !== serverSideExperimentDecision || $[3] !== staticExperimentName) {
    t2 = () => {
      if (staticExperimentName) {
        datadogRum.addFeatureFlagEvaluation(staticExperimentName?.replace("-", "_"), serverSideExperimentDecision);
        datadogRum.addAction("Static ABSmartly Bucketing", {
          staticExperimentName
        });
      }
    };
    $[2] = serverSideExperimentDecision;
    $[3] = staticExperimentName;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== staticExperimentName) {
    t3 = [staticExperimentName];
    $[5] = staticExperimentName;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  if ($[7] !== children) {
    t4 = <>{children}</>;
    $[7] = children;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}